import { render } from "./DataComboBox.vue?vue&type=template&id=55d40f8a&ts=true"
import script from "./DataComboBox.vue?vue&type=script&lang=ts"
export * from "./DataComboBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__